import { ReturnRateOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ReturnRateState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/return-rate";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const ReturnRateDetails = memo(function ReturnRateDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ReturnRateState>) {
  const rateOptions: RedoListItem<ReturnRateOption>[] = useMemo(
    () =>
      Object.values(ReturnRateOption).map((option) => ({
        id: option,
        value: option,
        type: "text" as const,
        text: option,
      })),
    [],
  );

  const selectedOption = state.comparison
    ? rateOptions.find((option) => option.value === state.comparison)
    : undefined;

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label="Comparison"
        options={rateOptions}
        optionSelected={({ item }) =>
          setState({ ...state, comparison: item.value })
        }
        placeholder="Select comparison..."
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        description="The percentage of orders that have been returned by the customer"
        IconTrailing={() => <>%</>}
        label="Customer return rate"
        max={100}
        min={0}
        setValue={(value) => setState({ ...state, returnRate: value })}
        state={disabled ? "readonly" : "default"}
        value={state.returnRate}
      />
    </>
  );
});
